import React from 'react';
import { Button } from '@vp/swan';
import { usePromptContext } from 'src/providers/PromptContextProvider';
import { text } from 'src/utils/localizationUtil';

interface Props {
  onClickReviewGuidelines?: () => void;
  showFullWidth: boolean;
}

export const ReviewGuidelinesButton = ({ onClickReviewGuidelines, showFullWidth }: Props) => {
  const { setShowSpecsAndTemplatePrompt } = usePromptContext();

  const handleClick = () => {
    setShowSpecsAndTemplatePrompt(true);
    onClickReviewGuidelines?.();
  };

  return (
    <Button skin="primary" onClick={handleClick} width={showFullWidth ? 'full-width' : 'standard'}>
      {text('template-mismatch-dialog.review-guidelines')}
    </Button>
  );
};

ReviewGuidelinesButton.displayName = 'ReviewGuidelinesButton';
